import { ChangeEvent, useEffect, useId, useState } from 'react';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { FilterField, SearchInputField } from '@retail/components';
import { useDebounce } from '@retail/hooks';

interface Props {
  query: string | null;
  setQuery: (query?: string) => void;
}

export function ItemSearchFilter({ query, setQuery }: Props) {
  const t = useCalculusTFunction();
  const inputId = useId();
  const [value, setValue] = useState(query ?? '');
  const debouncedValue = useDebounce(value, 300);

  useEffect(() => {
    if ((query ?? '') !== debouncedValue) setValue(query ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useEffect(() => {
    if (debouncedValue !== (query ?? '')) setQuery(debouncedValue || undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  return (
    <FilterField label={t('calculus.itemSearch')} htmlFor={inputId} gap={1}>
      <SearchInputField
        id={inputId}
        margin="none"
        fullWidth
        placeholder={t('calculus.itemSearchPlaceholder')}
        value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => setValue(event.target.value)}
        onReset={() => setValue('')}
      />
    </FilterField>
  );
}
